//git hash 657b12df19f9a0382de75766eb33aa0b51010fb9
export default {
  'editionSettings': {
    'key': 'espn-pt-br',
    'site': 'espn',
    'language': 'pt',
    'country': 'br',
    'domain': 'www.espn.com.br',
    'editionSiteId': '26',
    'https': false,
    'supportsOneSite': true
  },
  'navId': '2703654',
  'dictionarySection': 'espn',
  'javaLocale': {
    'language': 'pt',
    'region': 'BR'
  },
  'dateTime': {
    'long': 'dddd MMMM d, yyyy',
    'medium': 'MMMM d, yyyy',
    'short': 'M/d',
    'timeFormat': 'h:mm',
    'firstDayOfWeek': 'Sunday',
    'timeZone': 'US/Eastern',
    'defaultFormat': 'd MMM, yyyy',
    'timeZoneString': 'ET',
    'timeZoneBucket': 'America/New_York',
    'MMM D, YYYY': 'D MMM, YYYY',
    'M/D/YYYY': 'D/M/YYYY',
    'MM/DD/YYYY': 'DD/MM/YYYY',
    'MMDDYYYY': 'DDMMYYYY',
    'MMMM Do YYYY': 'Do MMMM YYYY',
    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
    'M/D': 'D/M',
    'MMMM D, YYYY': 'D MMMM YYYY',
    'dddd, M/D': 'dddd, D/M',
    'age': {
      'seconds': 's',
      'minutes': 'm',
      'hours': 'h',
      'days': 'd'
    }
  },
  'numberFormat': {
    'long': '#,###',
    'short': '###',
    'currency': '#,###.00',
    'percent': '#.00%'
  },
  'temperature': {
    'scale': 'celsius',
    'symbol': '&deg; C'
  },
  'outbrain': {
    'enabled': true,
    'template': 'ESPNBrazil',
    'desktop': {
      'compliantId': 'AR_15',
      'nonCompliantId': 'AR_12'
    },
    'mobile': {
      'compliantId': 'MB_4',
      'nonCompliantId': 'MB_5'
    },
    'video': {
      'desktop': {
        'compliantId': 'AR_16'
      },
      'mobile': {
        'compliantId': 'MB_6'
      }
    },
    'report': {
      'desktop': {
        'compliantId': 'AR_6',
        'nonCompliantId': 'AR_30'
      },
      'mobile': {
        'compliantId': 'MB_3',
        'nonCompliantId': 'MB_9'
      }
    },
    'table': {
      'desktop': {
        'compliantId': 'AR_43'
      },
      'mobile': {
        'compliantId': 'MB_43'
      }
    },
    'game': {
      'desktop': {
        'compliantId': 'AR_48'
      },
      'mobile': {
        'compliantId': 'AR_48'
      }
    }
  },
  'omniture': {
    'enabled': true
  },
  'chartBeat': {
    'enabled': true
  },
  'ads': {
    'disabled': false,
    'network': 1234,
    'partnerAd': false,
    'dev-config': 21171680,
    'qa-config': 21171680,
    'prod-config': 21171680,
    'outputType': 'js',
    'featurePhone': {
      'outputType': 'no-js'
    }
  },
  'partnerModules': {
    'global': false,
    'nba': false,
    'womenbb': false,
    'golf': false,
    'endurance': false,
    'horse': false,
    'nascar': false
  },
  'sportBranding': [ {
    'sport': 'espnw',
    'image': 'espncom-apresentadopor-espnw',
    'url': '/espnw/'
  } ],
  'siteLogo': {
    'class': '',
    'featurePhone': {
      'name': 'espn-logo',
      'width': 45,
      'height': 11
    }
  },
  'meta': {
    'titleBranding': ' - ESPN',
    'description': 'ESPN',
    'defaultMetaImage': 'espn_red.png',
    'schema': {
      'name': 'ESPN'
    },
    'social': {
      'twitter': {
        'twitterId': '',
        'card': 'summary',
        'app_id_iphone': '317469184',
        'site': 'espn',
        'app_name_googleplay': 'ESPN',
        'app_id_googleplay': 'com.espn.score_center',
        'app_name_iphone': 'ESPN',
        'language': 'pt'
      },
      'facebook': {
        'id': '116656161708917',
        'og_site_name': 'ESPN.com.ar',
        'locale': 'pt_BR'
      }
    }
  },
  'shop': {
    'enabled': false
  },
  'sportReplacements': {
    'f1': 'f1',
    'cycling': 'cycling',
    'bola-de-prata': 'soccer',
    'data-espn': 'soccer',
    'ranking-dos-treinadores': 'soccer',
    'selecao-brasileira': 'soccer'
  },
  'uriRewrites': {
    'urls': {
      'toEdition': {
        '/beisbol/mlb/': '/beisbol/'
      },
      'toEnglish': {}
    },
    'roots': {
      'toEdition': {},
      'toEnglish': {}
    },
    'pathSegments':{
      'reporte': 'report',
      'jogo': 'game',
      'time': 'team',
      'elenco': 'roster',
      'estatisticas': 'stats',
      'calendario': 'schedule',
      'estadio': 'stadium',
      'profundidad': 'depth',
      'bate-papo': 'conversation',
      'placar': 'boxscore',
      'previa': 'preview',
      'partida': 'match',
      'minuto-a-minuto': 'playbyplay',
      'cronica': 'recap',
      'fotos': 'photos',
      'confronto': 'matchup',
      'classificacao': 'standings',
      'classificacao': 'table',
      'temporada': 'season',
      'resultados': 'scoreboard',
      'liga': 'league',
      'ligas': 'leagues',
      'artigo': 'story',
      'olimpiadas': 'olympics',
      'verao': 'summer',
      'comentarios': 'commentary',
      'escalacoes': 'lineups',
      'escalacao': 'lineup',
      'estatisticas-partida': 'matchstats',
      'jogador-estatisticas': 'playerstats',
      'deportes': 'sports',
      'atletas': 'athletes',
      'ranking': 'leaderboard',
      'jogador': 'player',
      'lesoes': 'injuries',
      'rebatendo': 'batting',
      'piloto': 'driver',
      'clipe': 'clip',
      'data': 'date'
    },
    'paramKeys': {
      'jogoId': 'gameId',
      'data': 'date',
      'nome': 'name',
      'partida': 'gameID',
      'temporada': 'season',
      'tipodetemporada': 'seasontype',
      'ano': 'year',
      'semana': 'week',
      'modalidade': 'discipline',
      'evento': 'event',
      'tournamentId': 'tournamentId',
      'atleta': 'athlete',
      'vs-division': 'view',
      'pais': 'country',
      'pagina': 'page',
      'continuo': 'continuous',
      'rodada': 'round',
      'posicao': 'position',
      'time': 'team',
      'ligas': 'leagues',
      'liga': 'league'
    },
    'paramValues': {
      'liga': 'league',
      'ligas': 'leagues',
      'todos': 'all',
      'atletas': 'athletes',
      'paises': 'countries'
    }
  },
  'betting': {
    'enabled': false,
    'provider': '',
    'game': {
      'enabled': false,
      'provider': ''
    }
  },
  'ticketProvider': null,
  'hasTickets': false,
  'showFavorites': true,
  'showInsider': false,
  'showWatch': true,
  'hideCategoryLinks': [
    600,
    1700
  ],
  'categorySettings': {
    'leagues': true,
    'athletes': true,
    'teams': true,
    'tags': true
  },
  'showFCContent': true,
  'showCricInfoContent': false,
  'cookieConsent': false,
  'scDeepLinking': true,
  'allowShortUrl': false,
  'allowPrintUrl': true,
  'allowUserAccountManagement': true,
  'nowFeed': false,
  'searchUrl': 'http://buscar.espn.com/',
  'gameSettings': {
    'topEventsId': 2993187,
    'promotedSoccerLeaguesCeId': 2993207,
    'showBroadcast': true
  },
  fallback: {
    'athletics': 'espn-pt-br-athletics-index',
    'baseball': 'espn-pt-br-baseball-index',
    'brazilian-basketball': 'espn-pt-br-brazilian-basketball-index',
    'bola-de-prata': 'espn-pt-br-bola-de-prata-index',
    'cycling': 'espn-pt-br-cycling-index',
    'data-espn': 'espn-pt-br-data-espn-index',
    'esports': 'espn-pt-br-esports-index',
    'espnw': 'espn-pt-br-espnw-index',
    'f1': 'espn-pt-br-f1-index',
    'futsal': 'espn-pt-br-futsal-index',
    'golf': 'espn-pt-br-golf-index',
    'jogo-limpo': 'espn-pt-br-jogo-limpo-index',
    'judo': 'espn-pt-br-judo-index',
    'mlb': 'espn-pt-br-baseball-index',
    'mma': 'espn-pt-br-mma-index',
    'rpm': 'espn-pt-br-motorsports-index',
    'nhl': 'espn-pt-br-nhl-index',
    'olympics': 'espn-pt-br-olympics-index',
    'poker': 'espn-pt-br-poker-index',
    'ranking-dos-treinadores': 'espn-pt-br-ranking-dos-treinadores-index',
    'rugby': 'espn-pt-br-rugby-index',
    'selecao-brasileira': 'espn-pt-br-selecao-brasileira-index',
    'soccer': 'espn-pt-br-soccer-index',
    'swimming': 'espn-pt-br-swimming-index',
    'surfing': 'espn-pt-br-surfing-index',
    'tennis': 'espn-pt-br-tennis-index',
    'volleyball': 'espn-pt-br-volleyball-index',
    'x-games': 'espn-pt-br-x-games-index'
  },
  'editionAlert': {
    'enabled': true,
    'text': 'Você está na Edição Brasil. Para acessar edições de outras regiões, clique aqui.'
  },
  'feeds': {
    'googlenews': {
      'allowedContentTypes': [
        'TopStoryPackage',
        'HeadlineNews',
        'BlogEntry'
      ]
    }
  },
  'tier2NavIds': {
    'athletics': 3608032,
    'baseball': 3608093,
    'brazilian-basketball': 3688079,
    'cycling': 3608094,
    'esports': 3608105,
    'espnw': 3608104,
    'f1': 3608106,
    'futsal': 3608108,
    'golf': 3608116,
    'jogo-limpo': 3608119,
    'judo': 3608128,
    'mlb': 3608093,
    'mma': 3608120,
    'rpm': 3608121,
    'nba': 3608080,
    'nfl': 3608122,
    'nhl': 3608123,
    'olympics': 3608283,
    'poker': 3608138,
    'rugby': 3608129,
    'selecao-brasileira': 3688073,
    'ranking-dos-treinadores': 3608107,
    'bola-de-prata': 3608107,
    'data-espn': 3608107,
    'soccer': 3608107,
    'surfing': 3608139,
    'tennis': 3608140,
    'volleyball': 3608141,
    'x-games': 3608143,
    'watch': 3046242
  },
  'tier3NavIds': {
    'clubhouse': {
      'nfl': 2993221,
      'mlb': 2993223,
      'nba': 2993227,
      'soccer': 2993231
    }
  },
  'indexAutoStart': false,
  'useMongo': false,
  'activeSite': true,
  'countries': [ {
    'name': 'Brazil',
    'country-code': 'br',
    'showHreflang': true
  } ],
  'reactOverride': {
    'cricket' : {
      'scores' : true
    }
  },
  'analytics' : {
    'site' : 'espnbr'
  }
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/portuguese/brazil.js